import { render } from "./ExtrachargeReportIndex.vue?vue&type=template&id=6c5436f0"
import script from "./ExtrachargeReportIndex.vue?vue&type=script&lang=js"
export * from "./ExtrachargeReportIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__